'use client';

import type { ButtonProps } from '@mui/material';
import { Box } from '@mui/material';
import { type ReactNode, useEffect, useState } from 'react';

import { Button, Spinner } from '@campaign-manager/react/components';

import { process } from './service';

interface Props {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  disabled?: boolean;
  type?: HTMLButtonElement['type'];
  variant?: ButtonProps['variant'];
  color?: ButtonProps['color'];
  size?: ButtonProps['size'];
}

export default function ChallengedButton({
  children,
  onClick,
  href,
  type,
  disabled,
  color,
  size,
  variant = 'contained',
}: Props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const fn = async () => {
      try {
        const isCookieSet = Boolean(
          document.cookie.split('; ').find((row) => row.startsWith('_rmt_user')),
        );
        if (isCookieSet) {
          console.log(
            `
       !
       !
       ^
      / \\
     /___\\
    |=   =|
    |     |
    |     |
    |     |
    |     |
    |     |
    |     |
    |     |
    |     |
    |     |
   /|##!##|\\
  / |##!##| \\
 /  |##!##|  \\
|  / ^ | ^ \\  |
| /  ( | )  \\ |
|/   ( | )   \\|
    ((   ))
   ((  :  ))
   ((  :  ))
    ((   ))
     (( ))
      ( )
       .
       .
       .
       
   Lift off!

`,
          );
          setLoading(false);
          return;
        }
      } catch (e) {
        console.log(e);
      }

      const timeStart = Date.now();
      try {
        await process('33a73eed-f4a3-4db2-a439-cadda70cafe6', 4);
        console.log('Challenge solved in', Date.now() - timeStart, 'ms');
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
        const expires = new Date();
        expires.setFullYear(expires.getFullYear() + 1);
        const domain = window.location.hostname.split('.').slice(-2).join('.');
        document.cookie = `_rmt_user=1; expires=${expires.toUTCString()}; domain=.${domain}; SameSite=Lax`;
      }
    };

    fn();
  }, []);

  if (loading) {
    return (
      <Button
        color={color}
        variant={variant}
        size={size}
        disabled
      >
        <Box sx={{ py: 1.25 }}>
          <Spinner size="small" />
        </Box>
      </Button>
    );
  }

  return (
    <Button
      color={color}
      variant={variant}
      size={size}
      href={href}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
